import React, { useState, useEffect } from 'react';
import '../styles/TagAndMentions.css';
import { Card, Row, Col } from 'react-bootstrap';
import HashtagSvg from '../assets/icons/hashtag-sign-icon.svg';
import AtSymbolSvg from '../assets/icons/attherate-icon.svg';
import { getTopHashtags, getTopMentions } from '../services/api';
import ErrorFallback from './ErrorFallback';

const TagAndMentions = ({ influencerId, platformAccountType }) => {
  const [topMentions, setTopMentions] = useState([]);
  const [topHashtags, setTopHashtags] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [hashtagsResponse, mentionsResponse] = await Promise.all([
          getTopHashtags(influencerId, platformAccountType),
          getTopMentions(influencerId, platformAccountType),
        ]);

        if (hashtagsResponse.status === 404 || mentionsResponse.status === 404) {
          setError("Profile not found. Please check the influencer ID.");
        } else {
          setTopHashtags(hashtagsResponse.data || []);
          setTopMentions(mentionsResponse.data || []);
          setError(null);
        }
      } catch (error) {
        setTopHashtags([]);
        setTopMentions([]);
        setError("An error occurred while fetching the details.");
      }
    };

    fetchData();
  }, [influencerId, platformAccountType]);
  // 👉 Return fallback if empty or error
  if (error || topMentions.length === 0 || topHashtags.length === 0) {
      return (
        <ErrorFallback
          title="HashTags & Mentions"
          image={require('../assets/icons/audience-empty1.svg').default} // update to match your image path if needed
        />
      );
    }
  const renderTagSection = (icon, title, subtitle, items) => (
    <div className="tags-card-container">
      <div className="tags-card-header-container">
        <div className="tags-card-header-icon">
          <img src={icon} alt={title} className='mx-1' width={24} height={24} />
        </div>
        <div className="tags-card-header-tooltip-container mx-2">
          <div className="info-header-title m-0">{title}</div>
          <div className="tags-card-description h6">{subtitle}</div>
        </div>
      </div>
      <div className="tags-scroll-container box-root p-3 border audience-border-radius">
        <div className="tags-container">
          {items.map((item, index) => (
            <div className="label-container" key={index}>
              <div className="tag-name">{item.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <Card className="box-root audience-section border rounded-0">
      <Card.Body>
        <Row className="justify-content-center">
          {topHashtags.length > 0 && (
            <Col md={6} className="mb-4 mb-md-0">
              {renderTagSection(
                HashtagSvg,
                'Frequently used hashtags',
                'Hashtags frequently used by the creator in their content',
                topHashtags
              )}
            </Col>
          )}
          {topMentions.length > 0 && (
            <Col md={6} >
              {renderTagSection(
                AtSymbolSvg,
                'Frequently tagged accounts',
                'Accounts frequently tagged by the creator in their content',
                topMentions
              )}
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TagAndMentions;